import { useState } from 'react';

import {
  INDIVIDUAL_VIEW,
  QUESTION_VIEW,
  SUGGESTED_VIEW,
} from 'approot/activity-builder/classroom/classroom-answer-tabs';
import { ComponentDiscussion } from '../component.constants';
import DiscussionViewAnswer from './discussion-view-answer';
import DiscussionResponseIndividual from 'approot/activity-builder/classroom/discussion/discussion-response-individual';
import DiscussionResponseSuggestedAnswers from 'approot/activity-builder/classroom/discussion/discussion-response-suggested-answer';
import ActivitySheet from '../shared/sheet/activity-sheet';
import {
  ActivitySheetGridMax,
  ActivitySheetInnerContent,
  ActivitySheetInnerMax,
} from '../shared/sheet/activity-sheet.style';

type Props = Omit<ComponentDiscussion, '__typename'> & {
  isPublished: boolean;
  isPublic: boolean;
  canRespond: boolean;
  closeModal: () => void;
};

const DiscussionAnswerTeacher = (props: Props) => {
  const { closeModal } = props;

  const [tab, setTab] = useState<string>(QUESTION_VIEW);

  return (
    <ActivitySheet
      isVisible
      title="Discussion Response"
      hasBackgroundColor={tab === QUESTION_VIEW}
      onClose={() => {
        setTab(QUESTION_VIEW);
        closeModal();
      }}
    >
      {tab === QUESTION_VIEW && <DiscussionViewAnswer {...props} />}
      {tab === INDIVIDUAL_VIEW && (
        <ActivitySheetInnerContent id="content">
          <ActivitySheetGridMax>
            <DiscussionResponseIndividual component={props} />
          </ActivitySheetGridMax>
        </ActivitySheetInnerContent>
      )}
      {tab === SUGGESTED_VIEW && (
        <ActivitySheetInnerContent id="content">
          <ActivitySheetInnerMax>
            <DiscussionResponseSuggestedAnswers component={props} />
          </ActivitySheetInnerMax>
        </ActivitySheetInnerContent>
      )}
    </ActivitySheet>
  );
};

export default DiscussionAnswerTeacher;
